/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { IFlatTreeNode } from '../../../core/components';
import { SaveMapHierarchyScoping } from '../../../core/store/actions';

@Component({
  selector: 'fm-vehicle-list-scoping',
  templateUrl: './vehicle-list-scoping.component.html',
  styleUrls: ['./vehicle-list-scoping.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleListScopingComponent implements OnInit {
  public get treeData(): IFlatTreeNode<string>[] {
    return this._treeData;
  }

  selectedNodesCount: number;
  totalNodesCount: number;

  private _selectedNodes: IFlatTreeNode<string>[];
  private _treeData: IFlatTreeNode<string>[];

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) private readonly _dialogData: any,
    private readonly _dialog: MatLegacyDialog,
    private readonly _store: Store<any>
  ) {}

  ngOnInit(): void {
    this._treeData = this._dialogData.treeNodes;
    this.totalNodesCount = this._treeData.length;
  }

  onCancel(): void {
    this._dialog.closeAll();
  }

  onSave(): void {
    this._store.dispatch(new SaveMapHierarchyScoping(this._selectedNodes.map(node => node.id)));
  }

  onSelectionChange(selectedNodes: IFlatTreeNode<string>[]): void {
    this._selectedNodes = selectedNodes;
    this.selectedNodesCount = selectedNodes.length;
  }
}
